/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usersettings_Title1Inputs */

const zh_usersettings_title1 = /** @type {(inputs: Usersettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人详情`)
};

const en_usersettings_title1 = /** @type {(inputs: Usersettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Details`)
};

const es_usersettings_title1 = /** @type {(inputs: Usersettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos personales`)
};

/**
* | output |
* | --- |
* | "Personal Details" |
*
* @param {Usersettings_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usersettings_title1 = /** @type {((inputs?: Usersettings_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usersettings_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usersettings_title1(inputs)
	if (locale === "en") return en_usersettings_title1(inputs)
	return es_usersettings_title1(inputs)
});
export { usersettings_title1 as "userSettings_title" }